import * as React from "react";
import {connect} from "react-redux";
import {
    localizeRoadObjects,
    LocalizeRoadObjects,
    localizeRoadObjectsWithSkriv,
    LocalizeRoadObjectsWithSkriv,
    setOverwriteRoadCategory,
    SetOverwriteRoadCategory, SetOverwriteRoadUserGroup, setOverwriteRoadUserGroup
} from "../actions";
import * as selectors from "../selectors";
import LocationalState, {LocationalRoadObject, SelectedLocalizationType} from "../LocationalState";
import {RoadSegment} from "../../../../integration/representation/road-segment";
import {LatLng} from "leaflet";
import {contractId} from "../../contract-features-3/selectors";

interface TagProps {
}

interface DispatchProps {
    doSelectOverwriteRoadCategory: SetOverwriteRoadCategory;
    doLocalizeRoadObjects: LocalizeRoadObjects
    doLocalizeRoadObjectsWithSkriv: LocalizeRoadObjectsWithSkriv,
    doSelectOverwriteRoadUserGroup: SetOverwriteRoadUserGroup;
}

interface StateProps {
    selectedRoadSegment: RoadSegment,
    selectedRoadObjects: LocationalRoadObject[],
    selectedRoadObjectIdsInBatches: string[][],
    startAnchor: LatLng,
    endAnchor: LatLng,
    selectionIsLocalizable: boolean,
    useSkrivLocationals: boolean,
    useAnchors: boolean,
    selectedLocalizationType: SelectedLocalizationType,
    allRoadCategories: Record<string, string>,
    overwriteRoadCategory: string,
    overwriteRoadUserGroup: string,
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        selectedRoadSegment: selectors.selectedRoadSegment(state),
        selectedRoadObjects: selectors.selectedRoadObjects(state),
        selectedRoadObjectIdsInBatches: selectors.selectedRoadObjectIdsInBatches(state),
        startAnchor: selectors.startAnchor(state),
        endAnchor: selectors.endAnchor(state),
        selectionIsLocalizable: selectors.selectionIsLocalizable(state),
        useSkrivLocationals: selectors.useSkrivLocationals(state),
        useAnchors: selectors.useAnchors(state),
        selectedLocalizationType: selectors.selectedLocalizationType(state),
        allRoadCategories: selectors.allRoadCategories(state),
        overwriteRoadCategory: selectors.selectedOverwriteRoadCategory(state),
        overwriteRoadUserGroup: selectors.selectedOverwriteRoadUserGroup(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSelectOverwriteRoadCategory: setOverwriteRoadCategory,
    doSelectOverwriteRoadUserGroup: setOverwriteRoadUserGroup,
    doLocalizeRoadObjects: localizeRoadObjects,
    doLocalizeRoadObjectsWithSkriv: localizeRoadObjectsWithSkriv,
});

class Component extends React.Component<Props, {}> {

    render(){
        const {selectionIsLocalizable} = this.props;

        return (
            <div className={"locationalTool"}>
                <label htmlFor={'overwriteRoadCategory'}>Vegens kategori</label>
                <select id={'overwriteRoadCategory'} name={'overwriteRoadCategory'} value={this.props.overwriteRoadCategory} onChange={(e) => this.handleCategoryChange(e)}>
                    <option key={'NO_CAT'} value={"null"}>Ikke velg kategori</option>
                    {
                        (Object.entries(this.props.allRoadCategories)).map(([category, name]) => <option key={category} value={category}>{category} - {name}</option>)
                    }
                </select>
                {
                    /*
                    <label htmlFor={'overwriteRoadUserGroup'}>Overskriv vegbrukergruppe</label>
                    <select id={'overwriteRoadUserGroup'} value={this.props.overwriteRoadUserGroup} onChange={(e) => this.handleRoadUserGroupChange(e)}>
                        <option value={'K'}>K - Kjørende</option>
                        <option value={'G'}>G - Gående og syklende</option>
                    </select>
                    */
                }
                <button className={"btn"} onClick={() => this.handleLocalizeClick()} disabled={!selectionIsLocalizable}>Stedfest valgte vegobjekter</button>
            </div>
        );
    }

    handleCategoryChange(event: React.ChangeEvent<HTMLSelectElement>) {
        this.props.doSelectOverwriteRoadCategory(event.target.value);
    }

    handleRoadUserGroupChange(event: React.ChangeEvent<HTMLSelectElement>) {
        this.props.doSelectOverwriteRoadUserGroup(event.target.value);
    }

    handleLocalizeClick(){
        const {startAnchor, endAnchor, selectedRoadObjects, selectedRoadObjectIdsInBatches, selectedRoadSegment,
            useSkrivLocationals, useAnchors, selectedLocalizationType, overwriteRoadCategory} = this.props;
        if (useSkrivLocationals) {
            let positions: L.LatLng[];
            if (useAnchors) {
                if (selectedLocalizationType === SelectedLocalizationType.POINT) {
                    positions = [startAnchor];
                } else if (selectedLocalizationType === SelectedLocalizationType.LINE) {
                    positions = [startAnchor, endAnchor];
                }
            }

            // TODO NVDB-6185 Race condition on status update if mother and child are in different batches
            selectedRoadObjectIdsInBatches.forEach(batch => {
                this.props.doLocalizeRoadObjectsWithSkriv(batch, selectedRoadSegment, positions, overwriteRoadCategory);
            })
        } else {
            this.props.doLocalizeRoadObjects(selectedRoadObjects, selectedRoadSegment, startAnchor, endAnchor);
        }

    }
}

export const LocationalTool = connect(mapStateToProps, mapDispatchToProps)(Component);